module.exports = __webpack_public_path__ + "img/kind1.21118ff8.png";